module.exports = __webpack_public_path__ + "img/journey.7293d45d.jpg";